import React from 'react';
import { Users, PhoneCall, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export function TwoCoreOffers() {
  return (
    <div className="pt-4 pb-10 bg-black/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12">
          Pick Your Struggle
        </h2>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Card 1 - Marketing */}
          <div className="bg-gray-900/50 backdrop-blur-sm border border-blue-500/20 rounded-lg p-8 hover:border-blue-500/40 transition-all">
            <div className="flex items-center gap-3 mb-4">
              <Users className="w-8 h-8 text-blue-500" />
              <h2 className="text-2xl font-bold text-white">I need more (or better) clients</h2>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Done-for-you social media and simple local marketing so your clinic looks active, trustworthy, and easy to book—without you logging into Facebook after a 10-hour day.
            </p>
            <ul className="space-y-3 mb-8">
              <li className="flex items-start gap-3 text-gray-300">
                <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 flex-shrink-0" />
                <span>We clean up and optimize your Facebook (and optionally Instagram) profiles.</span>
              </li>
              <li className="flex items-start gap-3 text-gray-300">
                <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 flex-shrink-0" />
                <span>We post consistent, educational content that builds local trust.</span>
              </li>
              <li className="flex items-start gap-3 text-gray-300">
                <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 flex-shrink-0" />
                <span>We create simple offers and calls-to-book that match your clinic and ideal clients.</span>
              </li>
            </ul>
            <Link
              to="/marketing"
              className="inline-flex items-center gap-2 px-6 py-3 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 transition-colors"
            >
              Learn about Marketing Support
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          {/* Card 2 - Lead Rescue */}
          <div className="bg-gray-900/50 backdrop-blur-sm border border-blue-500/20 rounded-lg p-8 hover:border-blue-500/40 transition-all">
            <div className="flex items-center gap-3 mb-4">
              <PhoneCall className="w-8 h-8 text-blue-500" />
              <h2 className="text-2xl font-bold text-white">My phones are busy and we're dropping leads</h2>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Missed-call and lead-rescue automation that catches the clients you're already paying to attract, and plugs them back into your booking system automatically.
            </p>
            <ul className="space-y-3 mb-8">
              <li className="flex items-start gap-3 text-gray-300">
                <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 flex-shrink-0" />
                <span>Instant text when you miss a call, so potential patients aren't left hanging.</span>
              </li>
              <li className="flex items-start gap-3 text-gray-300">
                <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 flex-shrink-0" />
                <span>Automatic follow-ups if they don't reply right away.</span>
              </li>
              <li className="flex items-start gap-3 text-gray-300">
                <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 flex-shrink-0" />
                <span>Every lead logged in one place so nothing slips through the cracks.</span>
              </li>
            </ul>
            <Link
              to="/automation"
              className="inline-flex items-center gap-2 px-6 py-3 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 transition-colors"
            >
              Learn about Lead Rescue
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
